import React, { memo } from 'react';
import styled from 'styled-components';
import { CloseIcon } from '../common/utilities/closeIcon';

interface LifeNavCloseButtonProps {
    returnPath: string;
    close: () => void;
}
export const LifeNavCloseButton = memo(({
    returnPath,
    close
}: LifeNavCloseButtonProps) => {

    return (
        <Container onClick={close} href={returnPath}>
            <CloseIcon width={37} height={37} strokeColor='' />
        </Container>
    );
});

LifeNavCloseButton.displayName = 'LifeNavCloseButton';

const Container = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 48px;
    transform: translate(0%, 0%);
    cursor: pointer;
    margin-bottom: 30px;
`;